enum ImportErrorType {
  CSV_INVALID_CLOSING_QUOTE = "CSV_INVALID_CLOSING_QUOTE",
  INVALID_OPENING_QUOTE = "INVALID_OPENING_QUOTE",
  CSV_INCONSISTENT_RECORD_LENGTH = "CSV_INCONSISTENT_RECORD_LENGTH",
  CSV_RECORD_DONT_MATCH_COLUMNS_LENGTH = "CSV_RECORD_DONT_MATCH_COLUMNS_LENGTH",
  CSV_NON_TRIMABLE_CHAR_AFTER_CLOSING_QUOTE = "CSV_NON_TRIMABLE_CHAR_AFTER_CLOSING_QUOTE",
  CSV_QUOTE_NOT_CLOSED = "CSV_QUOTE_NOT_CLOSED",
  UNKNOWN = "UNKNOWN",
  VALIDATION_FAILED = "VALIDATION_FAILED",
  EMPTY_FILE = "EMPTY_FILE",
  ROW_OVERFLOW_ERROR = "ROW_OVERFLOW_ERROR",
  IMPORT_ID_NOT_FOUND = "IMPORT_ID_NOT_FOUND",
  CSV_HEADER_MALFORMED = "CSV_HEADER_MALFORMED",
  DUPE_COLUMN_NAME = "DUPE_COLUMN_NAME",
}

export default ImportErrorType;
